import { connect } from 'react-redux';
import View404 from '../components/404View/404View';

export const Page404 = connect()(View404);

export const Route404 = {
  path: '*',
  components: Page404,
};
